module.exports = __webpack_public_path__ + "static/media/para-voce.80042fb6.jpg";